<template>
  Artificial intelligence, is a broad term that refers to the ability of a computer to mimic human intelligence
</template>
